import React from "react";

import { useTranslation } from "react-i18next";

import { CustomerPortalMilestoneStep } from "../../../../../../../models/customer.portal";
import { MilestonesStepDetails } from "../../../../../../../util/enums";
import { StyledVeticalWrapper } from "../StepAction/styles";
import { StepDescription, StepLinkDescription, SubStepDetail } from "./styles";

interface ISubStepAction {
  stepDetails: CustomerPortalMilestoneStep[];
  closeMilestoneDrawer: () => void;
  onOpenShipment: (shipmentId: number) => void;
  shipmentId?: number;
}

export const SubStepAction = ({
  stepDetails,
  closeMilestoneDrawer,
  onOpenShipment,
  shipmentId,
}: ISubStepAction) => {
  const { t: translate } = useTranslation();

  const currentDetails = stepDetails.find(
    (detail) => detail.action === MilestonesStepDetails.current
  );

  function handleOnClickShipment() {
    if (shipmentId) {
      closeMilestoneDrawer();
      onOpenShipment(shipmentId);
    }
  }

  if (shipmentId) {
    if (currentDetails && currentDetails.description) {
      return (
        <SubStepDetail onClick={handleOnClickShipment}>
          <StyledVeticalWrapper gap="4px">
            <StepLinkDescription>{currentDetails.description}</StepLinkDescription>
          </StyledVeticalWrapper>
        </SubStepDetail>
      );
    }

    return (
      <SubStepDetail>
        <StyledVeticalWrapper gap="4px">
          <StepDescription>{translate("noTrackingAvailable")}</StepDescription>
        </StyledVeticalWrapper>
      </SubStepDetail>
    );
  }

  return <></>;
};
